module.exports = __webpack_public_path__ + "img/chevron-down-10012022.cd8d36d2.svg";